export const getMissingSystemTypeError = (systems, sectionLabel) => {
  const missingTypeIndex = systems.findIndex((system) => {
    if (!system || typeof system.systemType !== 'string') {
      return true;
    }

    return system.systemType.trim() === '';
  });

  if (missingTypeIndex === -1) {
    return null;
  }

  return `${sectionLabel} System ${missingTypeIndex + 1} Type is required.`;
};
